// actionTypes
export const UPDATE_TITLE = "UPDATE_NEWS_TITLE";
export const UPDATE_SLUG = "UPDATE_NEWS_SLUG";
export const UPDATE_SHORT_DESCRIPTION = "UPDATE_NEWS_SHORT_DESCRIPTION";
export const UPDATE_CONTENT = "UPDATE_NEWS_CONTENT";
export const UPDATE_THUMBNAIL_IMAGE = "UPDATE_NEWS_THUMBNAIL_IMAGE";
export const UPDATE_FEATURED_IMAGE = "UPDATE_NEWS_FEATURED_IMAGE";
export const UPDATE_ADDITIONAL_IMAGES = "UPDATE_NEWS_ADDITIONAL_IMAGES";

// action creators
export const updateTitle = (title) => ({
  type: UPDATE_TITLE,
  payload: title,
});

export const updateSlug = (slug) => ({
  type: UPDATE_SLUG,
  payload: slug,
});

export const updateShortDescription = (shortDescription) => ({
  type: UPDATE_SHORT_DESCRIPTION,
  payload: shortDescription,
});

export const updateContent = (content) => ({
  type: UPDATE_CONTENT,
  payload: content,
});

export const updateThumbnailImage = (thumbnailImage) => ({
  type: UPDATE_THUMBNAIL_IMAGE,
  payload: thumbnailImage,
});

export const updateFeaturedImage = (featuredImage) => ({
  type: UPDATE_FEATURED_IMAGE,
  payload: featuredImage,
});

export const updateAdditionalImages = (additionalImages) => ({
  type: UPDATE_ADDITIONAL_IMAGES,
  payload: additionalImages,
});
